import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate',
  standalone: true
})
export class TruncatePipe implements PipeTransform {

  transform(value: string, limit: number = 200): string {
    if (!value) return '';

    const plainText = value.replace(/<[^>]*>/g, '');

    return plainText.length > limit
      ? plainText.substring(0, limit) + '...'
      : plainText;
  }

}
